<template>
  <div class="member-log-page">
    <div class="nav-btn-group">
      <div class="tabs">
        <span
          :class="{ active: choiceNav === 'actionLog' }"
          @click="choiceNavHandel('actionLog')"
          >操作日志</span
        >
        <span
          :class="{ active: choiceNav === 'betLog' }"
          @click="choiceNavHandel('betLog')"
          >投注日志</span
        >
      </div>
      <div class="nav">
        <span style="margin-right: 10px" v-if="choiceNav === 'betLog'"
          >彩种:</span
        >
        <DropDownMenu
          style="margin-right: 30px"
          v-if="choiceNav === 'betLog'"
          :dropList="gameList"
          v-model="choiceOption"
        />
        <span style="margin-right: 10px">类型:</span>
        <DropDownMenu
          style="margin-right: 30px"
          v-if="choiceNav === 'actionLog'"
          :dropList="actionLogList"
          v-model="actionLogType"
        />
        <DropDownMenu
          style="margin-right: 30px"
          v-else
          :dropList="betLogList"
          v-model="betLogType"
        />
        <span style="margin-right: 10px" v-if="choiceNav === 'betLog'"
          >路径:</span
        >
        <DropDownMenu
          style="margin-right: 30px"
          v-if="choiceNav === 'betLog'"
          :dropList="playTypeList"
          v-model="choicePlayType"
        />
        <span style="margin-right: 10px">日期:</span>
        <DropDownMenu
          style="margin-right: 30px"
          :dropList="beforDateList"
          v-model="beforDate"
        />
        <span style="margin-right: 10px" v-if="choiceNav === 'betLog'"
          >订单号:</span
        >
        <input
          style="margin-right: 30px"
          v-if="choiceNav === 'betLog'"
          type="text"
          class="order-id input left"
          v-model="orderId"
        />
        <input
          class="btn primary"
          type="button"
          @click="getList()"
          value="查询"
        />
      </div>
    </div>
    <div class="content">
      <table v-if="choiceNav === 'actionLog'" cellpadding="0" cellspacing="0">
        <thead>
          <th>用户</th>
          <th>操作时间</th>
          <th>操作类型</th>
          <th>IP</th>
          <th>归属地</th>
          <th>操作</th>
        </thead>
        <tbody v-if="dataList.length > 0">
          <tr v-for="item in dataList" :key="item.id">
            <td style="color: var(--new-text-active)">{{ item.username }}</td>
            <td>{{ item.timeStamp | timeFormate }}</td>
            <td>
              {{
                item.type == "login"
                  ? "登录"
                  : item.type == "changepwd"
                  ? "修改密码"
                  : item.type == "odds"
                  ? "修改赔率"
                  : "-"
              }}
            </td>
            <td>{{ item.ip }}</td>
            <td>{{ item.area }}</td>
            <td>
              <a
                style="color: blue; cursor: pointer"
                v-if="item.type == 'odds'"
                @click="oddsDetail(item)"
                >详情</a
              >
              <span v-else>-</span>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="6" style="background: transparent; height: 300px">
              <div class="noData"></div>
            </td>
          </tr>
        </tbody>
      </table>
      <table v-else-if="choiceNav === 'betLog'" cellpadding="0" cellspacing="0">
        <thead>
          <th>用户</th>
          <th>投注时间</th>
          <th>订单号</th>
          <th>期号</th>
          <th>投注类型</th>
          <th>玩法路径</th>
          <th>IP</th>
          <th>归属地</th>
          <th>操作</th>
        </thead>
        <tbody v-if="dataList.length > 0">
          <tr v-for="item in dataList" :key="item.id">
            <td>{{ item.username }}</td>
            <td>{{ item.timeStamp | timeFormate }}</td>
            <td>{{ item.orderId }}</td>
            <td>{{ item.issue }}</td>
            <td>
              {{
                item.playCode == "D1W"
                  ? "一字定"
                  : item.playCode == "D2W"
                  ? "二字定"
                  : item.playCode == "D3W"
                  ? "三字定"
                  : item.playCode == "D4W"
                  ? "四字定"
                  : item.playCode == "daoru"
                  ? "txt导入"
                  : "-"
              }}
            </td>
            <td>
              {{
                item.playType == "zhixuan"
                  ? "直选"
                  : item.playType == "kuaixuan"
                  ? "快选"
                  : item.playType == "kuaida"
                  ? "快打"
                  : item.playType == "daoru"
                  ? "导入"
                  : item.playType == "robot"
                  ? "机打"
                  : "-"
              }}
            </td>
            <td>{{ item.ip }}</td>
            <td>{{ item.area }}</td>
            <td>
              <a
                class="active-text"
                style="cursor: pointer"
                @click="betDetail(item)"
                >详情</a
              >
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="9" style="background: transparent; height: 300px">
              <div class="noData"></div>
            </td>
          </tr>
        </tbody>
      </table>
      <Paging
        class="center"
        :current_page="current_page"
        :last_page="last_page"
        :total="total"
        @pre="pre()"
        @next="next()"
        @goFirst="firstPage()"
        @goLast="lastPage()"
        @jumper="jumper"
      />
    </div>

    <!-- 投注详情 -->
    <div class="confirm-bet-wrapper" v-show="showBetDetail">
      <div
        class="confirm-bet"
        tabindex="0"
        ref="confirmBet"
        v-show="showBetDetail"
      >
        <h1 class="title">
          投注详情<i class="el-icon-close" @click="showBetDetail = false"></i>
        </h1>
        <div class="content">
          <table cellpadding="0" cellspacing="0">
            <thead>
              <tr>
                <th>号码</th>
                <th>赔率</th>
                <th>金额</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in betDetailObj" :key="index">
                <td>{{ item.number }}</td>
                <td>{{ item.peilv || "-" }}</td>
                <td>{{ (item.money * 1).toFixed(2) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- 修改赔率详情 -->
    <div class="confirm-bet-wrapper" v-show="showOddsDetail">
      <div
        class="confirm-bet"
        tabindex="0"
        ref="confirmBet"
        v-show="showOddsDetail"
      >
        <h1 class="title">
          详情<i class="el-icon-close" @click="showOddsDetail = false"></i>
        </h1>
        <div class="content">
          <table cellpadding="0" cellspacing="0">
            <thead>
              <tr>
                <th>类别</th>
                <th>改前</th>
                <th>改后</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in oddsDetailObj"
                :key="index"
                class="cursor"
                mystate="3"
              >
                <td>{{ item.sonProject }}</td>
                <td>{{ item.orgBack }}</td>
                <td>{{ item.back }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DropDownMenu from "@/components/DropDownMenu";
import Paging from "@/components/Paging";
export default {
  data() {
    return {
      access_token: "",
      uid: "",
      showBetDetail: false,
      showOddsDetail: false,
      betDetailObj: null,
      oddsDetailObj: null,
      choiceOption: "hn5fc",
      choiceNav: "actionLog",
      actionLogType: "login",
      choicePlayType: "",
      actionLogList: [
        {
          label: "修改赔率",
          value: "odds",
        },
        {
          label: "修改密码",
          value: "changepwd",
        },
        {
          label: "登录日志",
          value: "login",
        },
      ],
      betLogType: "",
      betLogList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "一定",
          value: "D1W",
        },
        {
          label: "二定",
          value: "D2W",
        },
        {
          label: "三定",
          value: "D3W",
        },
        {
          label: "四定",
          value: "D4W",
        },
        {
          label: "txt导入",
          value: "daoru",
        },
        {
          label: "快打",
          value: "kuaida",
        },
      ],
      dataList: [],
      beforDate: this.$getBeforeDate(0, "yyyy-MM-dd"),
      gameList: [],
      playTypeList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "直选",
          value: "zhixuan",
        },
        {
          label: "快打",
          value: "kuaida",
        },
        {
          label: "快选",
          value: "kuaixuan",
        },
        {
          label: "机打",
          value: "robot",
        },
      ],
      orderId: "",
      current_page: 1,
      last_page: 0,
      total: 0,
      limit: 15,
    };
  },
  mounted() {
    this.initData();
  },
  watch: {
    current_page(newVal) {
      // if(newVal){
      this.getList();
      // }
    },
    actionLogType(newVal) {
      // if(newVal){
      this.getList();
      // }
    },
    beforDate(newVal) {
      // if(newVal){
      this.getList();
      // }
    },
    betLogType(newVal) {
      // if(newVal){
      this.getList();
      // }
    },
    choicePlayType(newVal) {
      // if(newVal){
      this.getList();
      // }
    },
    initFinished() {
      this.initData();
    },
  },
  methods: {
    async initData() {
      if (this.initFinished) {
        this.computedGameList();
        this.getList();
      }
    },
    choiceNavHandel(type) {
      this.choiceNav = type;
      if (this.current_page == 1) {
        this.getList();
      } else {
        this.current_page = 1;
      }
    },
    firstPage() {
      this.current_page = 1;
    },
    pre() {
      if (this.current_page > 1) {
        this.current_page--;
      }
    },
    next() {
      if (this.current_page < this.last_page) {
        this.current_page++;
      }
    },
    lastPage() {
      this.current_page = this.last_page;
    },
    jumper(page) {
      if (page) {
        this.current_page = page;
      }
    },
    betDetail(item) {
      this.betDetailObj = JSON.parse(item.content);
      if (item.playCode == "D1W") {
        this.betDetailObj.forEach((it) => {
          if (it.peilv) {
            it.peilv = (it.peilv * 1).toFixed(2);
          }
        });
      } else {
        this.betDetailObj.forEach((it) => {
          if (it.peilv) {
            it.peilv = (it.peilv * 1).toFixed(1);
          }
        });
      }
      this.showBetDetail = true;
    },
    oddsDetail(item) {
      this.oddsDetailObj = JSON.parse(item.content);
      this.showOddsDetail = true;
    },
    async getList() {
      if (this.choiceNav === "actionLog") {
        //操作日志
        this.getActionList();
      } else if (this.choiceNav === "betLog") {
        //投注日志
        this.getBetLog();
      }
    },
    async getActionList() {
      let data = {
        access_token: this.$store.state.userInfo.access_token,
        uid: this.$store.state.userInfo.uid,
        type: this.actionLogType,
        beforeDate: this.beforDate,
        page: this.current_page,
        limit: this.limit,
      };
      let result = await this.$http.postAxiosMethod("/user/actionlog", data);
      if (result.code == 0) {
        this.dataList = result.data;
        this.last_page = Math.ceil((result.count || 0) / this.limit);
        this.total = result.count || 0;
      }
    },
    async getBetLog() {
      let data = {
        access_token: this.$store.state.userInfo.access_token,
        uid: this.$store.state.userInfo.uid,
        play_code: this.betLogType,
        play_type: this.choicePlayType,
        orderId: this.orderId,
        beforeDate: this.beforDate,
        page: this.current_page,
        limit: this.limit,
      };
      let result = await this.$http.postAxiosMethod("/user/betlog", data);
      if (result.code == 0) {
        this.dataList = result.data;
        this.last_page = Math.ceil((result.count || 0) / this.limit);
      }
    },
    computedGameList() {
      this.$store.state.gameInfo.forEach((element) => {
        this.gameList.push({
          label: element.gameName,
          value: element.code,
        });
      });
    },
  },
  components: {
    DropDownMenu,
    Paging,
  },
  props: ["initFinished"],
  computed: {
    beforDateList() {
      let arr = [];
      for (let i = 0; i < 7; i++) {
        let date = this.$getBeforeDate(i, "yyyy-MM-dd");
        arr.push({
          label: date,
          value: date,
        });
      }
      return arr;
    },
  },
};
</script>

<style lang="scss" scopde>
.member-log-page {
  background: var(--new-bg-white);
  .nav-btn-group {
    padding-left: 24px;
    display: flex;
    align-items: center;
    font-size: 12px;
    height: 45px;
    .tabs {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      > span {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 81px;
        height: 26px;
        color: var(--new-text);
        background: var(--new-primary-second-color);
        cursor: pointer;

        border: 1px solid var(--new-border);
        &:nth-child(1) {
          border-radius: 4px 0px 0px 4px;
        }
        &:nth-child(2) {
          border-radius: 0px 4px 4px 0px;
        }
        &.active {
          color: var(--new-text-primary-bg);
          background: var(--new-primary-color);
        }
      }
    }
  }
  .nav {
    margin-left: 30px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 40px;
    line-height: 40p;
    font-size: 12px;
    & > span {
    }
    .order-id {
      width: 180px;
      height: 22px;
      background: var(--new-bg-white);
      padding: 5px;
      font-size: 15px;
      border: 1px solid var(--new-border);
    }
    // .search {
    //   margin-left: 15px;
    //   width: 60px;
    //   // height: 25px;
    //   // background: linear-gradient(90deg, #54aff3, #2992e1, #1082d7);
    //   // border-radius: 2px;
    //   color: var(--new-bg-white);
    //   font-size: 14px;
    //   cursor: pointer;
    // }
  }
  .content {
    // margin-top: 14px;
    & > table {
      width: 100%;
      font-size: 12px;
      thead {
        th {
          padding: 0 20px;
          line-height: 40px;
          height: 40px;
          text-align: center;
          background: var(--new-bg-table-header-main);
          color: var(--new-text-info);
        }
      }
      td {
        padding: 0 10px;
        line-height: 40px;
        height: 35px;
        text-align: center;
      }
      tr {
        &:nth-child(n) {
          background: #fff;
        }
        &:nth-child(2n) {
          background: #f0f0f0;
        }
      }
    }
  }
  .confirm-bet-wrapper {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 2000;
    background: rgba(0, 0, 0, 0.6);
  }
  .confirm-bet {
    outline: none;
    position: fixed;
    top: 50%;
    left: 50%;
    width: 500px;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-bottom: 1px solid #bad4e8;
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
    font-size: 14px;
    border-radius: 10px;
    overflow: hidden;
    h1.title {
      position: relative;
      height: 70px;
      line-height: 70px;
      font-weight: normal;
      border-bottom: 1px solid var(--new-border);
      background: var(--new-bg-white);
      text-align: center;
      font-weight: bold;
      font-size: 24px;
      color: var(--new-text-active);
      i {
        top: 50%;
        right: 15px;
        transform: translateY(-50%);
        position: absolute;
        font-size: 14px;
        font-weight: bold;
        cursor: pointer;
      }
    }
    .content {
      max-height: 280px;
      overflow: auto;
      padding: 20px 15px;
      table {
        width: 100%;
      }
      .money {
        width: 55px;
        height: 22px;
        border-radius: 2px;
        padding: 0 5px;
      }
      .del-bet {
        margin: auto;
        cursor: pointer;
        width: 22px;
        height: 22px;
        text-align: center;
        line-height: 22px;
        border-radius: 50%;
        // background-color: #ff3737;
        color: #000;
        &:hover {
          color: var(--primary-active-text-color-2);
        }
        i {
          font-weight: bold;
        }
      }
      .bc {
        text-align: left;
        background: linear-gradient(to bottom, #fff, #bad4e8);
      }
      table {
        margin-bottom: 20px;
        width: 100%;
        font-size: 13px;
        border: 1px solid var(--primary-table-border-color);
        border-right: none;
        border-bottom: none;
        tr {
          border: 1px solid var(--primary-table-border-color);
        }
        th,
        td {
          height: 30px;
          line-height: 30px;
          text-align: center;
          // &:not(:last-child) {
          border-right: 1px solid var(--primary-table-border-color);
          border-bottom: 1px solid var(--primary-table-border-color);
          // }
        }
        &.report-detail {
        }
        thead {
          background: #f3f5fc;
        }
        // th {
        //   font-weight: bold;
        //   // color: #401e1e;
        //   &.bg {
        //     background: #f3f5fc;
        //   }
        // }
        tr:not(.sum) {
          cursor: pointer;
        }
        .sum {
          //   background-color: #f3f5fc;
          td {
            font-weight: bold;
            // color: #401e1e;
          }
        }
      }
    }
    .btn-group {
      margin: 10px 0 20px;
      padding: 5px 0;
      text-align: right;
      input[type="button"] {
        &:nth-child(1) {
          margin-right: 50px;
        }
        &:nth-child(2) {
          margin-right: 20px;
        }

        // width: 101px;
        // height: 34px;
        // border-radius: 2px;
        // color: #fff;
        // font-size: 16px;
        // &:nth-child(1) {
        //   background: linear-gradient(90deg, #01d5c1, #00b5b8, #0096ac);
        // }
        // &:nth-child(2) {
        //   background: linear-gradient(90deg, #54aff3, #2992e1, #1082d7);
        // }
      }
    }
  }
}
</style>
